<template>
  <Layout>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      loader="dots"
      :is-full-page="fullPage"
      :height="height"
      :width="width"
      background-color="#6b6969"
    />
    <template v-slot:navigation>
      <topNav />
    </template>
    <template v-slot:content>
      <div
        style="background-image:url('../../assets/images/partner-back.png'); background-size: cover; background-repeat: no-repeat;"
      >
        <div class="container">
          <div class="row" style="padding-top: 10rem; padding-bottom: 10rem">
            <div class="col-md-12">
              <div class="card">
                <form @submit.prevent="submitInfo">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-10 offset-md-1">
                        <h3 class="text-green text-center mb-5">
                          Log In
                        </h3>
                        <div class="form-group">
                          <label for="name" class="bmd-label-floating"
                            >Name</label
                          >
                          <input
                            id="name"
                            type="text"
                            class="form-control"
                            required
                            v-model="data.name"
                          />
                        </div>
                        <div class="form-group">
                          <label for="type" class="bmd-label-floating"
                            >Gender</label
                          >
                          <select
                            id="type"
                            class="form-control"
                            required
                            v-model="data.gender"
                          >
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                          </select>
                        </div>

                        <div class="form-group">
                          <label for="email" class="bmd-label-floating"
                            >Email</label
                          >
                          <input
                            type="email"
                            id="email"
                            required
                            v-model="data.email"
                            class="form-control"
                          />
                        </div>
                        <div class="form-group">
                          <label for="phone" class="bmd-label-floating"
                            >Phone</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="phone"
                            v-model="data.phone"
                          />
                        </div>
                        <div class="form-group">
                          <label for="passport" class="bmd-label-floating"
                            >Password</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="passport"
                            required
                            v-model="data.password"
                          />
                        </div>
                        <div class="form-group">
                          <label
                            for="confirm_passport"
                            class="bmd-label-floating"
                            >Confirm Password</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="confirm_passport"
                            required
                            v-model="data.confirm_password"
                          />
                        </div>

                        <div class="text-center mt-5 mb-5">
                          <button
                            class="btn btn-orange pt-2 pb-2"
                            style="border-radius: 10px;"
                          >
                            Register
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Layout>
</template>

<script>
import layout from "@/components/app-layout";
import navigation from "@/components/topNav";
import axios from "axios";
import {Api} from "../utils/endpoint.js";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Layout: layout,
    topNav: navigation,
    Loading
  },
  data: () => {
    return {
      data: {
        name: "",
        email: "",
        gender: "female",
        country: "",
        phone: "",
        password: "",
        confirm_password: "",
        isLoading: false,
        fullPage: true,
        height: 128,
        width: 128
      }
    };
  },
  methods: {
    submitInfo() {
      if (this.data.password !== this.data.confirm_password) {
        alert("Password and password confirmation does not match");
        return;
      }
      axios
        .post(`${Api.BASE_URL}/register-partner`, this.data)
        .then(res => {
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  created() {
    document.body.style.background = "#F3F7FF";
  },
  mounted() {}
};
</script>

<style scoped>
.input-group {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-align: stretch;
  align-items: stretch;
  width: 100%;
}
.input-group > .custom-file {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}
.input-group > .custom-file,
.input-group > .custom-select,
.input-group > .form-control,
.input-group > .form-control-plaintext {
  position: relative;
  -ms-flex: 1 1 0;
  flex: 1 1 0;
  min-width: 0;
  margin-bottom: 0;
}
.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin-bottom: 0;
}
.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin: 0;
  opacity: 0;
}
.input-group > .custom-file:not(:last-child) .custom-file-label,
.input-group > .custom-file:not(:last-child) .custom-file-label::after {
  content: "";
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}
.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border-bottom: 1px solid #ced4da;
}
.input-group-append {
  margin-left: -1px;
}
.input-group-append,
.input-group-prepend {
  display: -ms-flexbox;
  display: flex;
}
.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group
  > .input-group-prepend:first-child
  > .input-group-text:not(:first-child),
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group-text {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  border-bottom: 1px solid #ced4da;
}
</style>
